const setCookie = (name, value, expiration, domain) => {
  document.cookie = `${name}=${value}; expires=${expiration}; path=/; domain=${domain}`;
};

export default setCookie;